module.exports = __webpack_public_path__ + "static/100-deadly-skills-296ebca4adc4b4569607af69fe046139.jpg";